import { filter, flatMap, map, pipe } from '@canvas/streams';
import { fromReadable } from '@canvas/streams/generators';

export function parsePromptStream(
  body: ReadableStream<Uint8Array>,
  onError: (error: Error) => void
) {
  return pipe(
    fromReadable(body),
    flatMap((line) => line.split('\n')),
    filter((line) => !!line.trim() && line.trim() !== '[DONE]'),
    map((line) => {
      const dataMatch = line.match(/^data:\s*(.*)$/);
      const content = dataMatch ? dataMatch[1] : line;
      return content;
    }),
    map((content) => {
      try {
        const parsed = JSON.parse(content);
        if (parsed.delta?.text) {
          return parsed.delta.text;
        }
        return '';
      } catch (err) {
        onError(new Error(`Error processing JSON from stream: ${err}`));
        return '';
      }
    }),
    filter((text) => text.length > 0)
  );
}
